import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function AuthImage({ path, className = "", alt = "", onClick }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let revoke;
    let cancel = false;
    async function load() {
      try {
        const res = await api.get(`/files/${path}`, { responseType: "blob" });
        if (cancel) return;
        const u = URL.createObjectURL(res.data);
        revoke = u;
        setUrl(u);
      } catch {
        setErr(true);
      }
    }
    load();
    return () => {
      cancel = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path]);

  if (err) return <div className={`bg-zinc-900 flex items-center justify-center text-zinc-600 text-xs ${className}`}>IMAGE ERROR</div>;
  if (!url) return <div className={`bg-zinc-900 animate-pulse ${className}`} />;
  return <img src={url} alt={alt} className={className} onClick={onClick} />;
}

export function AuthVideo({ path, className = "" }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let revoke;
    let cancel = false;
    async function load() {
      try {
        const res = await api.get(`/files/${path}`, { responseType: "blob" });
        if (cancel) return;
        const u = URL.createObjectURL(res.data);
        revoke = u;
        setUrl(u);
      } catch {}
    }
    load();
    return () => { cancel = true; if (revoke) URL.revokeObjectURL(revoke); };
  }, [path]);
  if (!url) return <div className={`bg-zinc-900 animate-pulse ${className}`} />;
  return <video src={url} controls className={className} />;
}
